<template>
  <!-- pc权利监督大数据 -->
  <div class="right-supervise">
    <pc-layout>
      <!-- 头部广告位 -->
      <div class="banner outer">
        <img class="img" :src="background" />
        <div class="bannerin inner">
          <div class="info">
            <div class="info-title">
              权力监督大数据
            </div>
            <div class="info-desc">
              充分利用大数据技术，对海量的“中央八项规定、工程项目、招投标、行政审批、行政执法、民生资金、营商环境”等各领域相关权力行使行为痕迹数据以及与群众利益密切相关的数据进行采集、存储、整合、清洗，构建500+各类监督模型，对海量数据进行数据碰撞，高效、主动、精准发现问题线索，助力纪检监察主业主责提质增效。
            </div>
          </div>
        </div>
      </div>
      <!-- 页面内容 -->
      <div class="content">
          <!-- 页面四块块内容，根据背景色进行区别 -->
          <!-- 监督模型 -->
          <div class="section outer">
            <div class="sectionin inner">
              <div class="section-title">
                监督模型设计
              </div>
              <div class="section-sub">
                500+监督模型与您共享、随取随用，也可协助您建立具有本地特色的其他监督模型
              </div>
            </div>
          </div>
          <div class="section outer modelsection">
            <div class="sectionin inner">
              <div class="model">
                <div class="model-item">
                  <div class="model-title">
                    <img :src="gongchengxiangmuicon" />
                    <div class="title">工程项目监督</div>
                  </div>
                  <div class="model-page">
                    <div class="model-pageline">
                       <div class="model-pagetext">
                        程序类监督模型
                      </div>
                       <div class="model-pagetip">
                        工程产生较大变更
                      </div>
                    </div>
                    <div class="model-pageline">
                       <div class="model-pagetext">
                        关系类监督模型
                      </div>
                       <div class="model-pagetip">
                        领导干部及家属违规插手本区域工程
                      </div>
                    </div>
                    <div class="model-pageline">
                       <div class="model-pagetext">
                        共现类监督模型
                      </div>
                       <div class="model-pagetip">
                        存在多工程都以邀请招标方式发包且每次参与投标的企业相对固定
                      </div>
                    </div>
                    <div class="model-pageline">
                       <div class="model-pagetext">
                        管理类监督模型
                      </div>
                       <div class="model-pagetip">
                        领导干部个人主管项目过多
                      </div>
                    </div>
                    <div class="model-pageline">
                       <div class="model-pagetext">
                        资金类监督模型
                      </div>
                       <div class="model-pagetip">
                        工程产生较大变更
                      </div>
                    </div>
                    <div class="model-pageline">
                       <div class="model-pagetext">
                        质量类监督模型
                      </div>
                       <div class="model-pagetip">
                        肢解工程发包
                      </div>
                    </div>
                  </div>
                  <div class="model-more">
                  </div>
                </div>
                <div class="model-item">
                  <div class="model-title">
                    <img :src="zhaotoubiaoicon" />
                    <div class="title">招投标监督</div>
                  </div>
                  <div class="model-page">
                    <div class="model-pageline">
                       <div class="model-pagetext">
                        招标人（招标代理机构）异常
                      </div>
                       <div class="model-pagetip">
                        同一招标人中同一投标人或少数几个投标人中标概率过高
                      </div>
                    </div>
                    <div class="model-pageline">
                       <div class="model-pagetext">
                        投标人异常
                      </div>
                       <div class="model-pagetip">
                        存在协同投标、约定放弃投标等围标串标行为
                      </div>
                    </div>
                    <div class="model-pageline">
                       <div class="model-pagetext">
                        评标专家异常
                      </div>
                       <div class="model-pagetip">
                        专家违反评分习惯且中标单位的得分远高于其他投标人的平均分
                      </div>
                    </div>
                    <div class="model-pageline">
                       <div class="model-pagetext">
                        招投标过程异常
                      </div>
                       <div class="model-pagetip">
                        作废后重新招标并重新确定中标人或重新定义中标价
                      </div>
                    </div>
                    <div class="model-pageline">
                       <div class="model-pagetext">
                        招投标管理不规范
                      </div>
                       <div class="model-pagetip">
                        “黑名单”供应商在限制期参与投标
                      </div>
                    </div>
                  </div>
                  <div class="model-more">
                  </div>
                </div>
                <div class="model-item">
                  <div class="model-title">
                    <img :src="xingzhengshengpiicon" />
                    <div class="title">行政审批监督</div>
                  </div>
                  <div class="model-page">
                    <div class="model-pageline">
                       <div class="model-pagetext">
                        审批行为异常
                      </div>
                       <div class="model-pagetip">
                        对不具备申请资格或者不符合行政审批条件的 申请予以行政审批
                      </div>
                    </div>
                    <div class="model-pageline">
                       <div class="model-pagetext">
                        审批效能低
                      </div>
                       <div class="model-pagetip">
                        未一次告知申请人必须补正导致申请人反复提交
                      </div>
                    </div>
                    <div class="model-pageline">
                       <div class="model-pagetext">
                        自由裁量异常
                      </div>
                       <div class="model-pagetip">
                        同区域相似申请不同审批结果
                      </div>
                    </div>
                    <div class="model-pageline">
                       <div class="model-pagetext">
                        群众或企业投诉较多
                      </div>
                       <div class="model-pagetip">
                        群众或企业举报关于行政审批内容与实际不符
                      </div>
                    </div>
                    <div class="model-pageline">
                       <div class="model-pagetext">
                        审批对象异常
                      </div>
                       <div class="model-pagetip">
                        审批备案类事项多次指向一个单位或法人、高管等
                      </div>
                    </div>
                    <div class="model-pageline">
                       <div class="model-pagetext">
                        管理不规范
                      </div>
                       <div class="model-pagetip">
                        审批时限到期后无注销或续费记录
                      </div>
                    </div>
                  </div>
                  <div class="model-more">
                  </div>
                </div>
                <div class="model-item">
                  <div class="model-title">
                    <img :src="sheqihuiqizijinicon" />
                    <div class="title">涉企惠企资金监督</div>
                  </div>
                  <div class="model-page">
                    <div class="model-pageline">
                       <div class="model-pagetext">
                        弄虚作假套取涉企资金
                      </div>
                       <div class="model-pagetip">
                        同一贷款合同、设备采购合同重复使用或多次申报使用
                      </div>
                    </div>
                    <div class="model-pageline">
                       <div class="model-pagetext">
                        重复申报、多头申报骗取涉企资金
                      </div>
                       <div class="model-pagetip">
                        同一个项目分别申报中央、省、示范区同类项目资金
                      </div>
                    </div>
                    <div class="model-pageline">
                       <div class="model-pagetext">
                        财政补助资金挪作他用
                      </div>
                       <div class="model-pagetip">
                        财政资金已经拨付，项目尚未开工或建设进度滞后
                      </div>
                    </div>
                    <div class="model-pageline">
                       <div class="model-pagetext">
                        公职人员违规违纪违法行为
                      </div>
                       <div class="model-pagetip">
                        公职人员或近亲属违规经商办企业且相关企业享受相关涉企政策或涉企资金
                      </div>
                    </div>
                    <div class="model-pageline">
                       <div class="model-pagetext">
                        管理不到位
                      </div>
                       <div class="model-pagetip">
                        已注销的企业享受到涉企补助
                      </div>
                    </div>
                  </div>
                  <div class="model-more">
                  </div>
                </div>
                <div class="model-item">
                  <div class="model-title">
                    <img :src="xingzhengzhifaicon" />
                    <div class="title">行政执法监督</div>
                  </div>
                  <div class="model-page">
                    <div class="model-pageline">
                       <div class="model-pagetext">
                        处罚主体认定有误
                      </div>
                       <div class="model-pagetip">
                        存在应该处罚公司却处罚个人情况
                      </div>
                    </div>
                    <div class="model-pageline">
                       <div class="model-pagetext">
                        降格处罚
                      </div>
                       <div class="model-pagetip">
                        对比每一案件类型裁量平均金额，某案件处罚金额相对较低
                      </div>
                    </div>
                    <div class="model-pageline">
                       <div class="model-pagetext">
                        有案不立
                      </div>
                       <div class="model-pagetip">
                        多个群众或同一群众多次举报同一事项
                      </div>
                    </div>
                    <div class="model-pageline">
                       <div class="model-pagetext">
                        不作为、乱作为
                      </div>
                       <div class="model-pagetip">
                        短时间内完成案件处理全过程
                      </div>
                    </div>
                    <div class="model-pageline">
                       <div class="model-pagetext">
                        涉案财物管理不到位
                      </div>
                       <div class="model-pagetip">
                        已注销的企业享受到涉企补助
                      </div>
                    </div>
                  </div>
                  <div class="model-more">
                  </div>
                </div>
                <div class="model-item">
                  <div class="model-title">
                    <img :src="yingshanghuanjingicon" />
                    <div class="title">营商环境监督</div>
                  </div>
                  <div class="model-page">
                    <div class="model-pageline">
                       <div class="model-pagetext">
                        工程项目监督
                      </div>
                       <div class="model-pagetip">
                        程序类监督模型
                      </div>
                    </div>
                    <div class="model-pageline">
                       <div class="model-pagetext">
                        招投标监督
                      </div>
                       <div class="model-pagetip">
                        投标人异常
                      </div>
                    </div>
                    <div class="model-pageline">
                       <div class="model-pagetext">
                        行政审批监督
                      </div>
                       <div class="model-pagetip">
                        自由裁量异常
                      </div>
                    </div>
                    <div class="model-pageline">
                       <div class="model-pagetext">
                        涉企惠企资金监督
                      </div>
                       <div class="model-pagetip">
                        弄虚作假套取涉企资金
                      </div>
                    </div>
                    <div class="model-pageline">
                       <div class="model-pagetext">
                        行政执法监督
                      </div>
                       <div class="model-pagetip">
                        “黑名单”供应商在限制期参与投标
                      </div>
                    </div>
                  </div>
                  <div class="model-more">
                  </div>
                </div>
                <div class="model-item">
                  <div class="model-title">
                    <img :src="huiminbuzhuicon" />
                    <div class="title">惠民补助监督</div>
                  </div>
                  <div class="model-page">
                    <div class="model-pageline">
                       <div class="model-pagetext">
                        公职人员违规违纪违法行为
                      </div>
                       <div class="model-pagetip">
                        公职人员直接领取民生资金补助
                      </div>
                       <div class="model-pagetip">
                        优亲厚友
                      </div>
                    </div>
                    <div class="model-pageline">
                       <div class="model-pagetext">
                        重复申报、多头申报惠民补助
                      </div>
                       <div class="model-pagetip">
                        一卡通账户享受的补助次数最多
                      </div>
                       <div class="model-pagetip">
                        一户多卡
                      </div>
                    </div>
                    <div class="model-pageline">
                       <div class="model-pagetext">
                        群众投诉较多
                      </div>
                       <div class="model-pagetip">
                        群众举报存在挪用、私分、侵占或虚报民生资金补贴等问题
                      </div>
                    </div>
                    <div class="model-pageline">
                       <div class="model-pagetext">
                        管理不到位
                      </div>
                       <div class="model-pagetip">
                        死亡人口领取补贴
                      </div>
                       <div class="model-pagetip">
                        可疑数据最多的主管部门
                      </div>
                    </div>
                  </div>
                  <div class="model-more">
                  </div>
                </div>
                <div class="model-item">
                  <div class="model-title">
                    <img :src="baxiangguiding" />
                    <div class="title">八项规定监督</div>
                  </div>
                  <div class="model-page">
                    <div class="model-pageline">
                       <div class="model-pagetext">
                        违规发放津贴补贴或福利
                      </div>
                       <div class="model-pagetip">
                        违反规定发放加班费、值班费和未休年休假补贴
                      </div>
                    </div>
                    <div class="model-pageline">
                       <div class="model-pagetext">
                        违规公款吃喝
                      </div>
                       <div class="model-pagetip">
                        同一家饭店几次消费开票时间在1个月内或一家店在一个季度内消费金额过高
                      </div>
                    </div>
                    <div class="model-pageline">
                       <div class="model-pagetext">
                        违规配备使用公车问题
                      </div>
                       <div class="model-pagetip">
                        公务车非工作日加油、异地加油、混合加油、超油箱容量加油
                      </div>
                    </div>
                    <div class="model-pageline">
                       <div class="model-pagetext">
                        违规公款旅游
                      </div>
                       <div class="model-pagetip">
                        出差地点与报销的餐饮店的就餐地不一致
                      </div>
                    </div>
                    <div class="model-pageline">
                       <div class="model-pagetext">
                        提供或接受超标准接待
                      </div>
                       <div class="model-pagetip">
                        一函多餐：同一张公函却对应不同消费时间或金额的消费单据
                      </div>
                    </div>
                  </div>
                  <div class="model-more">
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- 监督机制 -->
          <div class="section outer">
            <div class="sectionin inner">
              <div class="section-title">
                监督机制建设
              </div>
              <div class="section-sub">
                打造全闭环监督，实现全流程自动流转、协同监督新模式，进一步强化监督的再监督职责
              </div>
            </div>
          </div>
          <div class="section outer">
            <div class="sectionin inner">
              <div class="rule">
                <div class="rule-top">
                  <div class="rule-tab">
                    <div class="rule-tab-title">
                      三色预警
                    </div>
                    <div class="rule-tab-txt">
                      通过监督模型，将权力运行数据与公职人员信息等辅助数据进行自动碰撞比对、深度分析研判，实时发现疑似问题，并根据问题性质及严重程度进行“红、橙、黄”三色预警。
                    </div>
                  </div>
                  <div class="rule-tab">
                    <div class="rule-tab-title">
                      三色督办
                    </div>
                    <div class="rule-tab-txt">
                      针对每一疑似问题，统一指挥调度核查任务，针对核查人员的核查进度进行“绿、橙、红”三色督办，确保核查任务得到及时完成。
                    </div>
                  </div>
                  <div class="rule-tab">
                    <div class="rule-tab-title">
                      协同治理
                    </div>
                    <div class="rule-tab-txt">
                      通过建立跨单位、跨平台的业务流程互联、数据信息共享，纪检组织及主管部门按照预警等级和问题性质分级分类核查处置，以及多方会商研判等机制，确保问题风险的高效协同处置，形成风险共知、责任共担、问题共治良性局面。
                    </div>
                  </div>
                </div>
                <div class="rule-bottom" id="rule-bottom">
                  <img class="rule-bottom-light lightred" :src="lightred" />
                  <img class="rule-bottom-light lightorange" :src="lightorange" />
                  <img class="rule-bottom-light lightyellow" :src="lightyellow" />
                  <img class="rule-bottom-bg" :src="jiandujizhi" />
                </div>
              </div>
            </div>
          </div>
          <!-- 智能聚合 -->
          <div class="section outer">
            <div class="sectionin inner">
              <div class="section-title">
                智能聚合信息，实现人、事、组织精准画像
              </div>
              <div class="section-sub tl">
                打造一键搜“人、单位、事”，横向打通纪委内部各条业务线数据，纵向贯通历史沉淀案件信息，实现对监督“人、单位、事”数据的全面掌握与动态查询，为日常监督、审查调查、巡察、追责问责提供有力支持
              </div>
            </div>
          </div>
          <div class="section outer">
            <div class="sectionin inner">
              <div class="injection"
                style="box-sizing:border-box; padding: 0 60px;">
                <div class="injection-left">
                  <div class="injection-tab">
                    <div class="injection-tab-title">
                      一键搜“人”
                    </div>
                    <div class="injection-tab-txt">
                      支持通过姓名、身份证、车牌号、手机号、单位等关键字的检索，第一时间找到“人”，实时了解公职人员基本信息、奖惩情况，考核情况、被举报投诉情况、个人重大事项报告情况、三圈关系图谱等。
                    </div>
                  </div>
                  <div class="injection-tab">
                    <div class="injection-tab-title">
                      一键搜“组织”
                    </div>
                    <div class="injection-tab-txt">
                      支持搜索单位名称（简称、别称）等，自动呈现单位现任及历任单位班子构成情况、班子成员基本信息、年度考核情况、主管的重大项目推进情况、承担的重点工作落实情况、群众举报投诉信息等。
                    </div>
                  </div>
                  <div class="injection-tab">
                    <div class="injection-tab-title">
                      一键搜“事”
                    </div>
                    <div class="injection-tab-txt">
                      支持输入项目名称或关键词，自动展现项目基本情况、招投标情况、项目进度、项目预警信息等。
                    </div>
                  </div>
                </div>
                <div class="injection-right">
                  <img :src="video" />
                  <!-- <video :src="video"
                    autoplay=""
                    controls /> -->
                </div>
              </div>
            </div>
          </div>
          <!-- 指挥决策 -->
          <div class="section outer">
            <div class="sectionin inner">
              <div class="section-title">
                指挥决策驾驶舱，可视化展示监督成效
              </div>
            </div>
          </div>
          <div class="section outer drivesection">
            <div class="sectionin inner">
              <div class="drive">
                <div class="drive-left">
                  <div class="dirve-item">
                    <div class="dirve-top">
                      <img :src="jianduchengxiaoicon" />
                      监督成效可视化
                    </div>
                    <div class="dirve-bottom">
                      秉持“先总后分、数据一网汇聚’，场景‘一屏透视’、问题‘一屏分析’”原则，利用热力地图、问题柱状图、时间趋势图等可视化图表，使用3D 动画、动效等酷炫元素确保以“视觉”高冲击力的方式展示区域在“中央八项规定、工程项目、招投标、行政审批、行政执法、民生资金、营商环境”监督方面的监督方式、创新举措、监督成效。
                    </div>
                  </div>
                  <div class="dirve-item">
                    <div class="dirve-top">
                      <img :src="zaixianzhihuiicon" />
                      在线指挥决策
                    </div>
                    <div class="dirve-bottom">
                      在保证领导“情况一屏感知”基础上，增加“指令‘一键下达’、问题快速流转、整改实时反馈、进度‘一屏统览’、治理‘一屏闭环’”等功能，便于领导进行全局管理、科学决策、快速敏捷的指挥调度与工作部署。
                    </div>
                  </div>
                </div>
                <div class="drive-right"
                  id="driveright">
                  <img :src="zhihuijuece" />
                </div>
              </div>
            </div>
          </div>
      </div>
    </pc-layout>
  </div>
</template>

<script>
import PcLayout from '@/components/layout.vue'
const gongchengxiangmuicon = 'https://examonlinebj.oss-cn-beijing.aliyuncs.com/webgw/image/rs1.png'
const zhaotoubiaoicon = 'https://examonlinebj.oss-cn-beijing.aliyuncs.com/webgw/image/rs2.png'
const xingzhengshengpiicon = 'https://examonlinebj.oss-cn-beijing.aliyuncs.com/webgw/image/rs3.png'
const sheqihuiqizijinicon = 'https://examonlinebj.oss-cn-beijing.aliyuncs.com/webgw/image/rs4.png'
const xingzhengzhifaicon = 'https://examonlinebj.oss-cn-beijing.aliyuncs.com/webgw/image/rs5.png'
const yingshanghuanjingicon = 'https://examonlinebj.oss-cn-beijing.aliyuncs.com/webgw/image/rs6.png'
const huiminbuzhuicon = 'https://examonlinebj.oss-cn-beijing.aliyuncs.com/webgw/image/rs7.png'
const baxiangguiding = 'https://examonlinebj.oss-cn-beijing.aliyuncs.com/webgw/image/rs8.png'
const jiandujizhi = 'https://examonlinebj.oss-cn-beijing.aliyuncs.com/webgw/image/rs9.png'
const jianduchengxiaoicon = 'https://examonlinebj.oss-cn-beijing.aliyuncs.com/webgw/image/rs10.png'
const zaixianzhihuiicon = 'https://examonlinebj.oss-cn-beijing.aliyuncs.com/webgw/image/rs11.png'
const zhihuijuece = 'https://examonlinebj.oss-cn-beijing.aliyuncs.com/webgw/image/rs12.png'
const background = 'https://examonlinebj.oss-cn-beijing.aliyuncs.com/webgw/image/rsbg.png'
const video = 'https://examonlinebj.oss-cn-beijing.aliyuncs.com/webgw/image/video.gif'
const lightred = 'https://examonlinebj.oss-cn-beijing.aliyuncs.com/webgw/image/lightred.gif'
const lightyellow = 'https://examonlinebj.oss-cn-beijing.aliyuncs.com/webgw/image/lightyellow.gif'
const lightorange = 'https://examonlinebj.oss-cn-beijing.aliyuncs.com/webgw/image/lightorange.gif'

export default {
  name: 'right-supervise',
  components: {
    PcLayout
  },
  data () {
    return {
      lightred,
      lightyellow,
      lightorange,
      video,
      gongchengxiangmuicon,
      zhaotoubiaoicon,
      xingzhengshengpiicon,
      sheqihuiqizijinicon,
      xingzhengzhifaicon,
      yingshanghuanjingicon,
      huiminbuzhuicon,
      baxiangguiding,
      jiandujizhi,
      jianduchengxiaoicon,
      zaixianzhihuiicon,
      zhihuijuece,
      background
    }
  },
  mounted () {
    document.body.scrollTop = 0
    document.body.parentNode.scrollTop = 0
    const observer = new IntersectionObserver((entries, b) => {
      for (const entry of entries) {
        const intersecting = entry.isIntersecting
        const domId = entry.target.getAttribute('id')
        if (intersecting) {
          if (domId === 'driveright') {
            entry.target.classList.add('on')
          }
          if (domId === 'rule-bottom') {
            entry.target.classList.add('on')
          }
        } else {
          if (domId === 'driveright') {
            entry.target.classList.remove('on')
          }
          if (domId === 'rule-bottom') {
            entry.target.classList.remove('on')
          }
        }
      }
    })
    observer.observe(document.getElementById('driveright'))
    observer.observe(document.getElementById('rule-bottom'))
  }
}
</script>

<style scoped lang="scss">
.right-supervise {
  .banner {
    // background-color: #fff;
    background-color: #0a1022;
    position: relative;
    z-index: 1;
    overflow: hidden;
    .img {
      position: absolute;
      z-index: 1;
      height: auto;
      width: 100%;
      display: block;
      left: 50%;
      top: 0;
      transform: translate(-50%, 0);
    }
    .bannerin {
      height: 580px;
      .info {
        position: relative;
        z-index: 2;
        height: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
        flex-direction: column;
        .info-title {
          font-size: 56px;
          font-family: Alibaba PuHuiTi, Alibaba PuHuiTi;
          font-weight: bold;
          color: #FFFFFF;
          line-height: 56px;
        }
        .info-desc {
          font-size: 16px;
          font-family: PingFang SC, PingFang SC;
          font-weight: bold;
          color: rgba(255,255,255,0.8);
          line-height: 44px;
          width: 599px;
          margin-top: 56px;
        }
      }
    }
  }
  .section {
    margin-top: 58px;
    margin-bottom: 54px;
    &:last-child {
      margin-bottom: 0;
    }
    .sectionin {
      display: flex;
      align-items: center;
      justify-content: center;
      flex-direction: column;
    }
    .section-title {
      font-size: 36px;
      font-family: PingFang SC, PingFang SC;
      font-weight: bold;
      color: #252525;
      line-height: 36px;
      text-align: center;
      margin-top: 88px;
    }
    .section-sub {
      font-size: 16px;
      font-family: PingFang SC, PingFang SC;
      font-weight: bold;
      color: #666666;
      line-height: 24px;
      margin-top: 16px;
      text-align: center;
      width: 1080px;
      &.tl {
        text-align: left;
      }
    }
    &.modelsection {
      background-color: #F2F6FF;
      padding: 60px 0 20px 0;
      .model {
        display: flex;
        align-items: flex-start;
        justify-content: flex-start;
        flex-wrap: wrap;
        width: 1680px;
        .model-item {
          width: 322px;
          height: 514px;
          background-color: #fff;
          box-sizing: border-box;
          padding: 32px 25px;
          display: flex;
          align-items: center;
          justify-content: center;
          flex-direction: column;
          margin-bottom: 40px;
          &:not(:nth-child(4n)) {
            margin-right: 89px;
          }
          &:nth-child(1) {
            .model-title {
              img {
                height: 29px;
              }
            }
          }
          &:nth-child(3) {
            .model-title {
              img {
                height: 28px;
              }
            }
          }
          &:nth-child(4) {
            .model-title {
              img {
                width: 28px;
                height: 40px;
              }
            }
          }
          .model-title {
            width: 100%;
            display: flex;
            align-items: center;
            justify-content: flex-start;
            height: 40px;
            margin-bottom: 18px;
            img {
              width: 40px;
              height: 40px;
              margin-right: 15px;
            }
            .title {
              font-size: 24px;
              font-family: Alibaba PuHuiTi, Alibaba PuHuiTi;
              font-weight: bold;
              color: #252525;
              line-height: 24px;
            }
          }
          .model-page {
            width: 100%;
            flex: 1;
            .model-pageline {
              margin-bottom: 18px;
              .model-pagetext {
                font-size: 16px;
                font-family: Alibaba PuHuiTi, Alibaba PuHuiTi;
                font-weight: 500;
                color: #252525;
                line-height: 16px;
              }
              .model-pagetip {
                display: flex;
                align-items: center;
                justify-content: flex-start;
                font-size: 12px;
                font-family: PingFang SC, PingFang SC;
                font-weight: 400;
                color: #252525;
                // line-height: 12px;
                line-height: 18px;
                margin-top: 8px;
                &:before {
                  content: '';
                  display: block;
                  width: 5px;
                  min-width: 5px;
                  height: 5px;
                  background-image: url('https://examonlinebj.oss-cn-beijing.aliyuncs.com/webgw/image/dot.png');
                  background-size: 100% 100%;
                  // background: #5475FF;
                  border-radius: 5px;
                  margin-right: 8px;
                }
              }
            }
          }
          .model-more {
            display: flex;
            align-items: center;
            justify-content: flex-start;
            width: 100%;
            &:before {
              content: '......';
              display: block;
              width: 31px;
              height: 6px;
              font-size: 16px;
              font-family: Alibaba PuHuiTi, Alibaba PuHuiTi;
              font-weight: 500;
              color: #252525;
              line-height: 16px;
            }
          }
        }
      }
    }
    .rule {
      margin-top: 60px;
      .rule-top {
        display: flex;
        align-items: center;
        justify-content: center;
        .rule-tab {
          width: 481px;
          height: 194px;
          background: #FFFFFF;
          border-radius: 0px 0px 0px 0px;
          opacity: 1;
          border: 1px solid #5475FF;
          display: flex;
          align-items: center;
          justify-content: flex-start;
          flex-direction: column;
          box-sizing: border-box;
          padding: 24px 32px 0 32px;
          flex: none;
          &:not(:last-child) {
            margin-right: 88px;
          }
          .rule-tab-title {
            font-size: 24px;
            font-family: Alibaba PuHuiTi, Alibaba PuHuiTi;
            font-weight: bold;
            color: #5475FF;
            line-height: 16px;
          }
          .rule-tab-txt {
            font-size: 15px;
            font-family: PingFang SC, PingFang SC;
            font-weight: 500;
            color: rgba(37,37,37,0.8);
            line-height: 32px;
            margin-top: 12px;
          }
        }
      }
      .rule-bottom {
        margin-top: 63px;
        position: relative;
        z-index: 1;
        .rule-bottom-bg {
          width: 1593px;
          height: 505px;
        }
        &.on {
          .rule-bottom-light {
            opacity: 1;
          }
        }
        .rule-bottom-light {
          width: 16px;
          height: 16px;
          position: absolute;
          z-index: 1;
          left: 550px;
          top: 0;
          opacity: 0;
        }
        .lightred {
          top: 113px;
          transition: all 1s ease 1s;
        }
        .lightyellow {
          top: 197px;
          transition: all 1s ease 1s;
        }
        .lightorange {
          top: 283px;
          transition: all 1s ease 1s;
        }
      }
    }
    .injection {
      margin-top: 60px;
      width: 1620px;
      height: 785px;
      background: #F2F6FF;
      display: flex;
      align-items: center;
      justify-content: center;
      .injection-left {
        margin-right: 183px;
        flex: 1;
        margin-right: 0;
        .injection-tab {
          width: 481px;
          height: 207px;
          border: 1px solid #5475FF;
          padding: 22px 32px 0 32px;
          display: flex;
          align-items: center;
          justify-content: flex-start;
          flex-direction: column;
          box-sizing: border-box;
          &:not(:last-child) {
            margin-bottom: 24px;
          }
          .injection-tab-title {
            font-size: 24px;
            font-family: Alibaba PuHuiTi, Alibaba PuHuiTi;
            font-weight: bold;
            color: #5475FF;
            line-height: 24px;
          }
          .injection-tab-txt {
            font-size: 16px;
            font-family: PingFang SC, PingFang SC;
            font-weight: 500;
            color: #252525;
            line-height: 32px;
            margin-top: 12px;
          }
        }
      }
      .injection-right {
        position: relative;
        z-index: 1;
        width: 860px;
        height: 669px;
        overflow: hidden;
        &:before {
          content: '';
          display: block;
          position: absolute;
          z-index: 1;
          border: 62px solid #F2F6FF;
          left: 50%;
          top: 50%;
          border-radius: 10px;
          transform: translate(-50%, -50%);
          width: calc(860px - 20px);
          height: calc(669px - 20px);
        }
        &:after {
          content: '';
          display: block;
          position: absolute;
          z-index: 2;
          border: 10px solid #fcfcff;
          left: 50%;
          top: 50%;
          border-radius: 10px;
          transform: translate(-50%, -50%);
          width: calc(860px - 20px);
          height: calc(669px - 20px);
        }
        img,
        video {
          width: calc(860px * 1);
          height: calc(669px * 1);
          transform: scale(1.07);
          background-color: #f5f5f5;
          object-fit: cover;
        }
      }
    }
    &.drivesection {
      background: #FBFBFB;
      padding: 65px 0 81px 0;
      .drive {
        display: flex;
        align-items: center;
        justify-content: center;
        .drive-left {
          margin-right: 120px;
          width: 600px;
          .dirve-item {
            display: flex;
            align-items: flex-start;
            justify-content: center;
            flex-direction: column;
            &:nth-child(1) {
              padding-bottom: 64px;
              border-bottom: 2px solid  #5475FF;
              margin-bottom: 64px;
            }
            .dirve-top {
              display: flex;
              align-items: center;
              justify-content: flex-start;
              font-size: 24px;
              font-family: PingFang SC, PingFang SC;
              font-weight: bold;
              color: #252525;
              line-height: 24px;
              img {
                width: 28px;
                height: 28px;
                margin-right: 24px;
              }
            }
            .dirve-bottom {
              font-size: 16px;
              font-family: PingFang SC, PingFang SC;
              font-weight: 500;
              color: #252525;
              line-height: 28px;
              margin-top: 20px;
            }
          }
        }
        .drive-right {
          width: 900px;
          height: 443px;
          overflow: hidden;
          &.on {
            img {
              transform: translate(0,0);
            }
          }
          img {
            width: 900px;
            height: 443px;
            transition: all 1s ease;
            transform: translate(100%, 0);
          }
        }
      }
    }
  }
}
</style>
